<template>
<div>
  <b-card title="Listado de Inspecciones con observaciones"
          tag="article">
    <template v-for="(item, index) in metafilter">
      <FormComponent :metadata='item' :dbfield='metanames[index]' :key='"comp_"+index'
        v-model="filter[metanames[index]]" :isSearch="true" />
    </template>
  </b-card>
  <b-alert variant="info" :show="msg != null">{{msg}}</b-alert>
  <b-progress :max="nVerificaciones" height="2rem">
    <b-progress-bar :value="curVerificaciones">
      Avance: <strong>{{ curVerificaciones }} / {{ nVerificaciones }}</strong>
    </b-progress-bar>
  </b-progress>
  <b-table :stacked="$route.params.typex === 'local'" striped hover :items="list" :fields="fields"
    :sort-compare="sortCompare" :sort-by.sync="order" :sort-desc.sync="desc">
    <template slot="options" slot-scope="data">
      <b-spinner label="Cargando..." v-if="!('permission' in data.item)"></b-spinner>
      <template v-else>
        <router-link v-if="data.item.permission.view" class="btn btn-info"
          :to="{ name: $route.params.json + '_view', params: { typex: $route.params.typex, json: $route.params.json, id: data.item._id } }">
          Ver
        </router-link>
        <router-link v-if="data.item.permission.edit" class="btn btn-info"
          :to="{ name: 'form', params: { typex: $route.params.typex, json: $route.params.json, id: data.item._id } }">
          Modificar
        </router-link>
        <b-button v-if="data.item.permission.delete" variant="danger" @click="deleteData(data.item,true)">Eliminar</b-button>
      </template>
    </template>
    <template slot="verificaciones" slot-scope="data">
      <b-spinner label="Cargando..." v-if="!('verificaciones' in data.item)"></b-spinner>
      <b-badge v-bind:key="i" v-for="(ver, i) in data.item.verificaciones"
        :variant="ver.type" v-b-tooltip.hover :title="ver.msg">{{ver.label}}
      </b-badge>
    </template>
  </b-table>
  <button v-if="more" @click="loadMore()" :disabled="isBusy">Cargar mas</button>
</div>
</template>
<script>
import Base from '../Base.vue'
import { mapState, mapActions } from 'vuex'
import FormComponent from '../FormComponents/FormComponent.vue'
import Vue from 'vue'

export default {
  extends: Base,
  components: {
    FormComponent
  },
  data () {
    return {
      list: [],
      fields: [],
      metafilter: [],
      metajoined: [],
      metanames: [],
      filter: {},
      send: false,
      current: null,
      total: 0,
      avance: 0,
      selector: null,
      bookmark: null,
      pageSize: 10,
      curpage: 0,
      isBusy: false,
      order: null,
      desc: false,
      more: true,
      testx: 0,
      curVerificaciones: 0,
      nVerificaciones: 0,
      metaVerificaciones: [
        this.verificacionCoordenadas
      ]
    }
  },
  mounted () {
    var obj = this
    window.onscroll = () => {
      if (this.$route.name === 'ot') {
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          obj.loadMore()
        }
      }
    }
  },
  watch: {
    current (to, from) {
      if (this.send) {
        if (to) {
          this.replicateCurrent()
        } else {
          this.newCurrent()
        }
      }
    },
    db (to, from) {
      this.loadFilter()
      this.loadHeader()
      if (to) {
        this.loadList()
      } else {
        this.clearList()
      }
    },
    send (to, from) {
      let obj = this
      if (to) {
        if (obj.msg) {
          obj.send = false
        } else {
          obj.total = 0
          obj.newCurrent()
        }
      } else {
        obj.loadList()
      }
    },
    filter: {
      handler: function (to) {
        this.loadList()
      },
      deep: true
    },
    msg (to) {
      this.send = false
    },
    order (to) {
      this.loadList()
    },
    desc (to) {
      this.loadList()
    },
    $route (to, from) {
      this.order = null
      this.desc = false
    }
  },
  computed: {
    ...mapState([
      'entities',
      'user'
    ])
  },
  methods: {
    ...mapActions([
      'get_db',
      'setMessage'
    ]),
    sortCompare (a, b, c) {
      return 0
    },
    replicateCurrent () {
      let obj = this
      this.replicate(obj.current).then(function () {
        obj.avance += 1
        obj.current = null
      }).catch(function (err) {
        console.log(err)
        if ('message' in err) {
          obj.msg = err.message
        } else {
          obj.msg = err.toString()
        }
        obj.setMessage('replicateCurrent: ' + JSON.stringify(err))
      })
    },
    newCurrent () {
      let obj = this
      var search = {
        selector: {
          $and: [
            { _id: { $ne: '_design/app' } },
            { _id: { $ne: '_design/index' } },
            { synced: { $exists: false } }
          ]
        }
      }
      obj.db.find(search).then(function (list) {
        if (list.docs.length) {
          if (obj.total === 0) {
            obj.total = list.docs.length
            obj.avance = 0
          }
          obj.$set(obj, 'current', list.docs[0])
        } else {
          obj.send = false
        }
      })
    },
    eachRecursive (index, joinedindex, obj, func) {
      for (var k in obj) {
        if (typeof obj[k] === 'object' && obj[k] !== null) {
          this.eachRecursive(k, joinedindex + '.' + k, obj[k], func)
          func(k, joinedindex + '.' + k, obj[k], true)
        } else {
          func(k, joinedindex + '.' + k, obj[k], false)
        }
      }
    },
    loadFilter () {
      var obj = this
      obj.metafilter = []
      obj.metanames = []
      this.eachRecursive('', '', this.metadata, function (metaname, joinedname, elem, isobject) {
        if (isobject && elem.search) {
          obj.metanames.push(metaname)
          obj.metajoined.push(joinedname.substr(1).replace(/.children/g, ''))
          obj.metafilter.push(elem)
        }
      })
    },
    loadHeader () {
      let fields = []
      /* let fields = [{
        key: '_id',
        label: 'id',
        sortable: true,
        order: true
      }] */
      var obj = this
      this.eachRecursive('', '', this.metadata, function (metaname, joinedname, met, isobject) {
        if (isobject && met.list) {
          var elem = {
            key: joinedname.substr(1).replace(/.children/g, ''),
            label: met.label,
            sortable: true,
            order: met.list
          }
          if (met.type === 'choice') { elem.formatter = obj.formatter(met) }
          fields.push(elem)
        }
      })
      fields.sort(function (a, b) { return a.order - b.order })
      /* ***************************** */
      fields.push({
        key: '_id',
        label: 'Creación',
        sortable: true,
        formatter: 'formatter_date'
      })
      /* ***************************** */
      fields.push({
        key: 'options',
        label: 'Opciones',
        sortable: false
      })
      /* ***************************** */
      fields.push({
        key: 'verificaciones',
        label: 'Verificaciones',
        sortable: false
      })
      /* ***************************** */
      this.$set(this, 'fields', fields)
      // this.fields = fields
    },
    clearList () {
      this.$set(this, 'list', [])
    },
    loadList () {
      let obj = this
      obj.isBusy = true
      // obj.db = obj.get_db()
      if (!obj.db) { return }
      var selector = {
        $and: [
          { _id: { $ne: '_design/app' } },
          { _id: { $ne: '_design/index' } }
        ]
      }
      if (obj.$route.params.typex === 'local') {
        selector['$and'].push({ synced: { $exists: false } })
      }
      for (var i in obj.metafilter) {
        if (obj.metanames[i] in obj.filter) {
          if (obj.metafilter[i].search.stype === 'range') {
            var partialfilter = {}
            partialfilter[obj.metajoined[i]] = {}
            if (obj.filter[obj.metanames[i]].start && obj.filter[obj.metanames[i]].start !== '') {
              partialfilter[obj.metajoined[i]]['$gte'] = obj.filter[obj.metanames[i]].start
            }
            if (obj.filter[obj.metanames[i]].end && obj.filter[obj.metanames[i]].end !== '') {
              partialfilter[obj.metajoined[i]]['$lte'] = obj.filter[obj.metanames[i]].end
            }
            if (!((!obj.filter[obj.metanames[i]].start || obj.filter[obj.metanames[i]].start === '') &&
              (!obj.filter[obj.metanames[i]].end || obj.filter[obj.metanames[i]].end === ''))) {
              selector['$and'].push(partialfilter)
            }
          } else {
            partialfilter = {}
            partialfilter[obj.metajoined[i]] = {
              $eq: obj.filter[obj.metanames[i]]
            }
            selector['$and'].push(partialfilter)
          }
        }
      }
      obj.$set(obj, 'selector', selector)
      obj.$set(obj, 'bookmark', null)
      var search = {
        selector: obj.selector,
        limit: obj.pageSize
      }
      if (obj.order) {
        search.sort = [{}]
        search.sort[0][obj.order] = obj.desc ? 'desc' : 'asc'
      }
      obj.db.find(search).then(function (list) {
        obj.$set(obj, 'list', list.docs)
        if (list.docs.length < obj.pageSize) {
          obj.more = false
        } else {
          obj.more = true
        }
        obj.isBusy = false
        obj.getPermission(0)
        obj.getVerificaciones(0)
        obj.$set(obj, 'bookmark', list.bookmark)
        obj.$set(obj, 'curpage', 0)
      }).catch(function (err) {
        console.log(err)
        if ('message' in err) {
          obj.msg = err.message
        } else {
          obj.msg = err.toString()
        }
        obj.setMessage('loadList: ' + JSON.stringify(err))
      })
    },
    loadMore () {
      var obj = this
      if (!obj.db.find || obj.isBusy) {
        return
      }
      obj.isBusy = true
      var search = {}
      if (obj.bookmark) {
        search = {
          selector: obj.selector,
          bookmark: obj.bookmark,
          limit: obj.pageSize
        }
      } else {
        search = {
          selector: obj.selector,
          limit: obj.pageSize,
          skip: (obj.curpage + 1) * obj.pageSize
        }
      }
      if (obj.order) {
        search.sort = [{}]
        search.sort[0][obj.order] = obj.desc ? 'desc' : 'asc'
      }
      obj.db.find(search).then(function (list) {
        // console.log(list)
        var num = obj.list.length
        obj.list.push(...list.docs)
        if (list.docs.length < obj.pageSize) {
          obj.more = false
        } else {
          obj.more = true
        }
        obj.getPermission(num)
        obj.getVerificaciones(num)
        obj.$set(obj, 'bookmark', list.bookmark)
        if (list.docs.length) {
          obj.curpage += 1
        }
        obj.isBusy = false
      }).catch(function (err) {
        console.log(err)
        if ('message' in err) {
          obj.msg = err.message
        } else {
          obj.msg = err.toString()
        }
        obj.setMessage('loadMore: ' + JSON.stringify(err))
        obj.isBusy = false
      })
    },
    getPermission (num) {
      var obj = this
      var i
      if (obj.$route.params.typex === 'local') {
        for (i = num; i < obj.list.length; i++) {
          obj.list[i].permission = {
            'view': true,
            'edit': true,
            'delete': true
          }
        }
      } else {
        var ids = []
        for (i = num; i < obj.list.length; i++) {
          ids.push(obj.list[i]._id)
        }
        this.dbconfig.get('config').then(function (config) {
          // var url = config.server + '/' + obj.$route.params.json + '/_design/app/_list/permission/permission'
          var url = obj.db.name + '/_design/app/_list/permission/permission'
          Vue.http.get(url, {
            withCredentials: true,
            params: {
              include_docs: true,
              keys: JSON.stringify(ids)
            }
          }).then(
            function (msj) {
              // console.log(msj)
              for (i = num; i < num + msj.body.length; i++) {
                obj.$set(obj.list[i], 'permission', msj.body[i - num].permission)
              }
            },
            function (err) {
              console.log(err)
              if ('message' in err) {
                obj.msg = err.message
              } else {
                obj.msg = err.toString()
              }
              obj.setMessage('getPermission: ' + JSON.stringify(err))
            }
          )
        })
      }
    },
    getVerificaciones (num) {
      var obj = this
      for (var j = 0; j < obj.metaVerificaciones.length; j++) {
        obj.metaVerificaciones[j](num)
      }
    },
    addData () {
      this.$router.push({ name: 'form', params: { typex: this.$route.params.typex, json: this.$route.params.json, id: 0 } })
    },
    modifyData (data) {
      this.$router.push({ name: 'form', params: { typex: this.$route.params.typex, json: this.$route.params.json, id: data._id } })
    },
    viewData (data) {
      this.$router.push({ name: this.$route.params.json + '_view', params: { typex: this.$route.params.typex, json: this.$route.params.json, id: data._id } })
    },
    deleteData (val, warn) {
      var obj = this
      if (warn) {
        this.$dialog.confirm('Seguro que desea eliminar el registro ?', { okText: 'Eliminar', cancelText: 'Cancelar' })
          .then(function () {
            obj.deleteData2(val)
          }).catch(function () {
            console.log('Clicked on cancel')
          })
      } else {
        obj.deleteData2(val)
      }
    },
    deleteData2 (val) {
      let obj = this
      this.deletedata(val).then(function () {
        obj.loadList()
      }).catch(function (err) {
        console.log(err)
        if ('message' in err) {
          obj.msg = err.message
        } else {
          obj.msg = err.toString()
        }
        obj.setMessage('deleteData2: ' + JSON.stringify(err))
      })
    },
    formatter (met) {
      let choices = {}
      for (var i in met.choices) {
        choices[met.choices[i].value] = met.choices[i].display_name
      }
      return function (val) {
        return choices[val]
      }
    },
    formatter_date (dat) {
      var d = new Date(parseInt(dat))
      return d.toISOString().replace(/T/g, ' + ').substring(0, 18)
    },
    verificacionCoordenadas (num) {
      var obj = this
      var i
      for (i = num; i < obj.list.length; i++) {
        // var insp = obj.list[i]._id
        if (!obj.list[i].location || !obj.list[i].location.east_coordinate || !obj.list[i].location.north_coordinate) {
          if (!obj.list[i].verificaciones) { obj.list[i].verificaciones = [] }
          obj.list[i].verificaciones.push({
            label: 'Coordenadas',
            msg: 'No se han ingresado las coordenadas',
            type: 'danger'
          })
        }
      }
    }
  }
}
</script>
